import React from 'react'
import { Global } from '@emotion/react'
import { WrapPageElementBrowserArgs } from 'gatsby'
import * as global from '@styles/global.css'
import { trackWebVitals } from '@src/utils/web-vitals'

export const wrapPageElement = ({ element }: WrapPageElementBrowserArgs) => {
  return (
    <>
      <Global styles={global} />
      {element}
    </>
  )
}

/**
 * Pomiar wydajności startuje po pierwszym renderze klienta, a nie przy
 * `wrapPageElement` — inaczej import biblioteki konkurowałby o pasmo z
 * zasobami, których czas ładowania ma mierzyć.
 *
 * Wyłącznie raz na wczytanie dokumentu: Core Web Vitals są zdefiniowane dla
 * odsłony dokumentu, nie dla przejścia między trasami w aplikacji SPA, więc
 * `onRouteUpdate` byłoby tu niepoprawnym miejscem.
 */
export const onInitialClientRender = () => {
  trackWebVitals()
}
